
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.644","height":"14.364"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"パス 77","d":"M8.321 14.364a1.226 1.226 0 01-.869-.36L1.301 7.853a4.633 4.633 0 016.531-6.571l.49.488.47-.469a4.633 4.633 0 016.57 6.531l-.575.575-3.657 3.657-1.94 1.94a1.226 1.226 0 01-.869.36z","fill":"#12b6d4"}})])
          )
        }
      }
    